import { Controller } from "stimulus";

export default class extends Controller {
  connect() {
    // console.log("connect::image-alternative-controller");

    // let parent = this.element.getAttribute("data-parent");

    // if (parent) {
    //   parent = document.querySelector(parent);
    // }
    // else {
    //   parent = this.element.parentNode;
    // }

    // let parentWidth = parent.innerWidth;

    if (this.element.offsetWidth > 600) {
      this.setBackground("data-big");
    }
    else if (this.element.offsetHeight > 420) {
      this.setBackground("data-big-vertical");
    }
  }

  // El original primero; luego image-set con webp, que el navegador que no lo
  // entienda ignora, quedandose con la primera asignacion.
  setBackground(attribute) {
    const url = this.element.getAttribute(attribute);
    const webp = this.element.getAttribute(`${attribute}-webp`);

    this.element.style.backgroundImage = `url(${url})`;

    if (webp) {
      this.element.style.backgroundImage = `image-set(url(${webp}) type("image/webp"), url(${url}))`;
    }
  }
}
